import { render, staticRenderFns } from "./GroupsPupils.vue?vue&type=template&id=705dfa72&"
import script from "./GroupsPupils.vue?vue&type=script&lang=js&"
export * from "./GroupsPupils.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports